import { Order } from "@/interfaces/order";
import { Item } from "@/interfaces/item";
import { Link, usePage } from "@inertiajs/react";
import Badge, { type BadgeTone } from "@/components/ui/Badge";

const STATE_TONES: Record<string, BadgeTone> = {
  pending: "brand",
  processing: "info",
  fulfilled: "success",
  cancelled: "danger",
};

export default function OrderCard({
  order,
}: {
  order: Order & { item: Item };
}) {
  const { props } = usePage();

  const content = (
    <>
      {order.item.image && (
        <div className="border-line bg-surface-plain shrink-0 overflow-hidden border">
          <img
            src={order.item.image}
            alt={order.item.name}
            className="h-16 w-16 object-contain"
          />
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-wrap items-center justify-between gap-2">
        <div className="min-w-0">
          {order.item.category && (
            <Badge className="mb-1">{order.item.category}</Badge>
          )}
          <p className="text-body text-ink font-bold">
            {order.quantity > 1 ? `${order.quantity}x ` : ""}
            {order.item.name}
          </p>
          <p className="text-caption text-ink-soft">
            Order #{order.id} · {order.amount_paid} ticket
            {order.amount_paid !== 1 && "s"}
          </p>
          {order.note && (
            <p className="text-caption text-ink-muted italic">{order.note}</p>
          )}
        </div>

        <Badge tone={STATE_TONES[order.aasm_state] ?? "neutral"}>
          {order.aasm_state}
        </Badge>
      </div>
    </>
  );

  const className =
    "border-line bg-surface shadow-card flex items-center gap-4 border-2 p-4";

  if (props.user.is_admin) {
    return (
      <Link
        href={`/shop/orders/${order.id}`}
        className={`${className} duration-fast ease-standard transition-transform hover:-translate-y-px`}
      >
        {content}
      </Link>
    );
  }

  return <div className={className}>{content}</div>;
}
